<script>
  import ValidatorMixin from "../mixins/validator";

  export default {
    props: {
      model: {
        type: Object,
        default: function () {
          return {};
        },
      },
      storeUrl: {
        type: String,
      },
    },

    data() {
      return {
        form: {},
        rules: {},
        errors: {},
        isBusy: false,
      };
    },

    computed: {
      /**
       * @return {Boolean}
       */
      isEditMode() {
        return !isNaN(_.get(this.model, 'id'));
      },

      /**
       * @return {String}
       */
      method() {
        return this.isEditMode ? 'PATCH' : 'POST';
      },
    },

    watch: {
      model: {
        handler: function (value) {
          this.initForm(value);
        },
        immediate: true,
      },
    },

    methods: {
      /**
       * @return {Object}
       */
      getForm() {
        return _.assign({}, this.form, {_method: this.method});
      },

      /**
       * @return {undefined}
       */
      store() {
        this.isBusy = true;
        axios.post(this.storeUrl, this.getForm(), this.getConfig())
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then((isBusy = false) => this.isBusy = isBusy);
      },

      /**
       * @param {Object} res
       * @return {boolean}
       */
      storeSuccess({data}) {
        this.$emit('stored', data);

        return Boolean(_.get(data, 'redirect'));
      },

      /**
       * @param {Object} response
       * @return {boolean}
       */
      handleErrorResponse({response: {data, status}}) {
        const {errors, message} = data || {};
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);
          this.$message.error(message);
        } else if (message && _.isString(message)) {
          this.$message.error(message);
        }

        return false;
      },

      /**
       * @param {Object} model
       */
      initForm(model) {
        //
      },

      /**
       * @return {Object}
       */
      getConfig() {
        return {};
      },
    },

    mixins: [
      ValidatorMixin
    ]
  }
</script>
